
import { defineComponent , reactive } from 'vue';
import { useStore } from 'vuex'
export default defineComponent({
    name: 'TopBar',
    props: {
        msg: String,
        viewIndex:{
            type:Number,
            default:1
        }
    },
    emits:['changeView'],
    setup(){
        const store = useStore()
        const signInfo = reactive(store.state.signInfo)
        return {
            signInfo
        }
    }
});
